import { cx } from "class-variance-authority";
import Image from "next/image";

import { Typography } from "@/components/ui/text/Typography/Typography";
import type { CommonModels } from "@/data/common/common.models";

interface UserAvatarProps {
  user?: CommonModels.BizUserDto;
}

export const UserAvatar = ({ user }: UserAvatarProps) => {
  return (
    <div
      className={cx(
        "flex h-9 w-9 flex-shrink-0 items-center justify-center overflow-hidden rounded-2xs bg-text-inverted-tertiary",
      )}
    >
      {user?.profilePictureUrl ? (
        <Image
          className={cx("h-full rounded-2xs object-cover")}
          src={user.profilePictureUrl}
          alt="User avatar"
          width={36}
          height={36}
        />
      ) : (
        <Typography
          size="label-4"
          variant="prominent-1"
          className="text-text-inverted-primary"
        >
          {user?.firstName?.charAt(0) ?? "U"}
        </Typography>
      )}
    </div>
  );
};
